// Shared session-binding guard for the web + React Native session managers, so
// the cross-principal refresh guard (#220 / #221) lives in ONE place and the two
// managers can't drift apart. Base64url decoding differs by platform (browser
// atob vs a configured decoder), so the caller passes its own decoder in.
/**
 * Extract the `custom:walletAddress` claim from a JWT idToken. Returns undefined
 * when the token has no wallet claim or cannot be decoded.
 */
export function idTokenWalletAddress(idToken, decodeBase64Url) {
    try {
        const payloadB64 = idToken.split(".")[1];
        if (!payloadB64)
            return undefined;
        const wallet = JSON.parse(decodeBase64Url(payloadB64))["custom:walletAddress"];
        return typeof wallet === "string" && wallet.length > 0 ? wallet : undefined;
    }
    catch (_a) {
        return undefined;
    }
}
/**
 * Whether a refreshed idToken may be grafted onto the CURRENTLY-stored session.
 *
 * A silent refresh started for user A can complete after storage was replaced
 * with user B (a login, guest→wallet upgrade, or a cross-tab login). Overwriting
 * B's tokens with A's — the app-id matches, so the old guard let it through —
 * installs a genuine-but-WRONG session: the UI shows B while the app authenticates
 * as A (#220 / #221). Refuse the write when the refreshed token binds to a
 * DIFFERENT wallet than the one currently stored. A tokenless/addressless session
 * (guest / opaque) preserves the prior behavior (returns true).
 */
export function refreshedTokenMayReplaceStored(newIdToken, storedAddress, decodeBase64Url) {
    const tokenWallet = idTokenWalletAddress(newIdToken, decodeBase64Url);
    if (!tokenWallet || !storedAddress)
        return true;
    return tokenWallet === storedAddress;
}
